import React, { useState } from 'react';
import Select from 'react-select';
import { Table } from "antd";

const OtherChargesTab = () => {
    const columns = [
        { title: "Type", dataIndex: "chargeHead", key: "chargeHead" },
        { title: "For", dataIndex: "basis", key: "basis" },
        { title: "Unit", dataIndex: "chargeType", key: "chargeType" },
        { title: "Freight", dataIndex: "override", key: "override" },
     
      ];
      const columns2 = [
        { title: "Charge Name", dataIndex: "chargeHead", key: "chargeHead" },
        { title: "Basis", dataIndex: "basis", key: "basis" },
        { title: "Curr", dataIndex: "chargeType", key: "chargeType" },
        { title: "Rate", dataIndex: "override", key: "override" },
     
      ];
      

const dataSource = [
{
key: "", // Add a unique key for each row
SNo: "", // Changed to camelCase

},
]

return (
<>
    <div className="row border-bottom-2 card m-1">
        <div className="col-md-12 card-body">
        
        <div className="row">

            <div className="col-md-6">
            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                       <span className="count-title">Freight Rate</span>
                                        </h4>
                                    </div>
                                  
                                </div>
                            </div>

            <div className="table-responsive custom-table">
                <Table className="table datanew dataTable no-footer" pagination={false} dataSource={dataSource}
                    columns={columns} />
            </div>
            </div>
            <div className="col-md-6">
            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                       <span className="count-title">Other Charges</span>
                                        </h4>
                                    </div>
                                  
                                </div>
                            </div>
<div className="table-responsive custom-table">
    <Table className="table datanew dataTable no-footer" pagination={false} dataSource={dataSource}
        columns={columns2} />
</div>
</div>


            
        </div>
            

            <div className="d-flex flex-wrap gap-2 mt-2 pb-2" style={{ borderBottom: '1px solid #d4d4d4' }}>
                <button className="btn btn-primary text-xs" type="button">
                    New
                </button>
                <button className="btn btn-primary text-xs" type="button">
                    Edit
                </button>
                <button className="btn btn-primary text-xs" type="button">
                    Cancel
                </button>
             
            </div>
        </div>
    </div>

</>
);
};

export default OtherChargesTab